var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C4 1.89543 4.89543 1 6 1H20C21.1046 1 22 1.89543 22 3V14H4V3Z",
    stroke: "#599ACF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 4,
    r: 1,
    fill: "#599ACF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11393 17.6061L3.6594 14H22.3406L23.8861 17.6061C24.1689 18.2659 23.6848 19 22.9669 19H3.03308C2.31516 19 1.83113 18.2659 2.11393 17.6061Z",
    stroke: "#599ACF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.e47198266e7f624f6be0e146b1b813ca.svg";
export { ForwardRef as ReactComponent };